import { render, staticRenderFns } from "./tabsContent.vue?vue&type=template&id=c458a482&lang=pug&"
import script from "./tabsContent.vue?vue&type=script&lang=js&"
export * from "./tabsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c458a482')) {
      api.createRecord('c458a482', component.options)
    } else {
      api.reload('c458a482', component.options)
    }
    module.hot.accept("./tabsContent.vue?vue&type=template&id=c458a482&lang=pug&", function () {
      api.rerender('c458a482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/components/common/tabsContent.vue"
export default component.exports